let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eNLLJ")).then(() => parcelRequire('40FP2'));